import { createStore } from "effector";
import { TChangePasswordStore } from "./types";
import { INITIAL_CHANGE_PASSWORD_STORE } from "./consts";
import { changePasswordInputType, resetErrors, resetFeaturesData, setInputValue, setPasswordsStore } from "./events";
import { confirmChangePasswordFx } from "./effects";

export const $changePasswordStore = createStore<TChangePasswordStore>(INITIAL_CHANGE_PASSWORD_STORE)
    .on(setInputValue, (state, { key, value }) => {
        return {
            ...state,
            [key]: {
                ...state[key],
                value: value,
            }
        }
    })
    .on(changePasswordInputType, (state, { key, type }) => {
        return {
            ...state,
            [key]: {
                ...state[key],
                type: type,
            }
        }
    })
    .on(setPasswordsStore, (_, data) => data)
    .on(resetErrors, (state, key) => {
        return {
            ...state,
            [key]: {
                ...state[key],
                isValid: true,
                errorMessage: '',
            },
        }
    })
    .reset(resetFeaturesData);


export const isPending = confirmChangePasswordFx.pending;

export const $shouldRedirect = createStore(false)
    .on(confirmChangePasswordFx.done, () => true)
    .reset(resetFeaturesData);